export default "__VITE_ASSET__CvA668Ts__"